import React, {useState} from 'react';
import axios from "axios";

const NewChat = ({allUsers, authRole, getConversations}) => {

    const [searchTerm, setSearchTerm] = useState('');

    const filteredUsers = allUsers?.filter((user) =>
        user?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const [expandedUser, setExpandedUser] = useState(null);

    const toggleSubList = (id) => {
        setExpandedUser(prev => (prev === id ? null : id));
    };

    const newChat = async (user) => {
        let admin = authRole === 'agency_admin' ? 1 : 0;
        let role = `${admin ? 'admin' : 'agent'}`;
        let userId = user.pivot ? user.pivot.id : user.id
        let is_cus = user.pivot ? true : false;

        const url = `/${role}/general-chat/${userId}/start-conversation`;

        try {
            const response = await axios.post(url, {
                is_customer: is_cus
            });

            if (response.data) {
                getConversations();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    return (
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content modal-new-conversation" style={{width: '100%'}}>
                <div className="modal-header pb-2 border-bottom">
                    <span className="modal-title" id="modalTitle">New Chat</span>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <input type="text" className="form-control mb-3" id="userSearchInput"
                           placeholder="search"
                           onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div style={{maxHeight: '500px', overflowY: 'auto'}} id="users">
                        {filteredUsers.map((user) => (
                            <div
                                key={user.id}
                                className="list-group chat-list"
                                data-name={user.name}
                                style={{cursor: 'pointer'}}
                                // onClick={newChat(user)}
                            >
                                <div
                                    className="list-group-item member-list-chat-select__list-item align-items-center"
                                    style={{height: '50px'}}
                                >
                                    <div className="conversation-img">
                                        <img
                                            src={user.avatar_image}
                                            className="rounded-circle"
                                            alt={user.name}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-between" style={{width: '100%'}}>
                                        <div className="ml-2">
                                            <div>{user.name} ({user.role ?? 'Customer'})</div>
                                            <div className="align-self-center">{user.email}</div>
                                        </div>
                                        {user.cus_role === 1 ? (
                                            <div onClick={() => toggleSubList(user.id)} style={{
                                                cursor: 'pointer',
                                                height: "24px",
                                                width: "24px",
                                                backgroundColor: "#e0e0e0",
                                                borderRadius: "4px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "8px"
                                            }}>
                                                {expandedUser === user.id ? '▼' : '▲'}
                                            </div>
                                        ) :
                                            <button className="user-chat-item btn btn-light btn-sm"
                                                    onClick={() => newChat(user)}
                                                    data-dismiss="modal"
                                                    data-image-url="https://www.gravatar.com/avatar/bc334613fda343d6b2a557609367b894?d=identicon"
                                                    data-user-name={user.name} data-user-id={user.id}>
                                                <i className="icon-comment-discussion"/>
                                            </button>}
                                    </div>
                                </div>

                                {user.cus_role === 1 && expandedUser === user.id && (
                                    <div className="pl-4">
                                        {user.users.map((customerUser) => (
                                            <div
                                                key={customerUser.id}
                                                className="list-group-item align-items-center"
                                                style={{height: '50px'}}
                                            >
                                                <div className="status-indicator-container conversation-img">
                                                    <img
                                                        src={customerUser.avatar_image}
                                                        className="rounded-circle"
                                                        alt={customerUser.name}
                                                    />
                                                    <span
                                                        className="status-indicator bg-danger"
                                                        data-status-id={customerUser.id}
                                                    />
                                                </div>
                                                <div className="d-flex justify-content-between" style={{width: '100%'}}>
                                                    <div className="ml-2">
                                                        <div>{customerUser.name}</div>
                                                        <div className="align-self-center">{customerUser.email}</div>
                                                    </div>
                                                </div>
                                                <button className="user-chat-item btn btn-light btn-sm"
                                                        onClick={() => newChat(customerUser)}
                                                        data-dismiss="modal"
                                                        data-image-url="https://www.gravatar.com/avatar/bc334613fda343d6b2a557609367b894?d=identicon"
                                                        data-user-name={user.name} data-user-id={user.id}>
                                                    <i className="icon-comment-discussion"/>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                        {allUsers.length === 0 && (
                            <div className="media justify-content-center text-muted">No User Found</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewChat;
